export const StoreOpenType = {
  OPEN_IN_24HR: 'OpenIn24/7',
  OPEN_IN_FLEXIBLE: 'OpenInFlexible',
};

export const Days: string[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const LocationType = [
  'Shopping Mall',
  'Shops',
  'Salon',
  'Corridor',
  'Theatres',
  'Food Court',
  'Parking Lot',
  'Healthcare',
  'Other',
];

export const bookingStatusOptions = [
  {
    id: 0,
    status: 'In Review',
  },
  {
    id: 3,
    status: 'Active',
  },
  {
    id: 4,
    status: 'Rejected',
  },
];

export const ContactSubjectType = [
  'Account Access',
  'Billing',
  'Considering SignGaze',
  'Legal & Privacy',
  'Technical Support',
  'Other',
];

export type ScreenCategory =
  | 'Arts'
  | 'Events & Entertainment'
  | 'Food & Eat'
  | 'Accommodation'
  | 'Drinks & Nightlife'
  | 'Outdoors'
  | 'Service'
  | 'Shops'
  | 'Medical'
  | 'Transport'
  | 'Government'
  | 'Sport & Wellness'
  | 'Finances'
  | 'Hospital'
  | 'Clinic'
  | 'Food';

export const ScreenCategories: ScreenCategory[] = [
  'Arts',
  'Events & Entertainment',
  'Food & Eat',
  'Accommodation',
  'Drinks & Nightlife',
  'Outdoors',
  'Service',
  'Shops',
  'Medical',
  'Transport',
  'Government',
  'Sport & Wellness',
  'Finances',
  'Hospital',
  'Clinic',
  'Food',
];

export interface ScreenImage {
  url: string;
  fileRef: string;
}

export const TouchPoints = [
  'Airport',
  'Apartment',
  'Automotive Retail',
  'Bus Station',
  'Cafe Network',
  'Clinics',
  'Co Living',
  'Corporate',
  'Co Working Space',
  'Electronic Retail',
  'Government Office',
  'Health Care',
  'High End Retail',
  'Hospitality',
  'Hyper Mart',
  'Mall',
  'Metro Station',
  'Outdoor Digital',
  'Personal Care',
  'Railway Station',
  'Residential',
  'Restaurant',
  'Retail',
  'Store',
  'Supermart',
];
